module.exports = __webpack_public_path__ + "1b6ffd2dcdfcc3080e6365f26e7e839c.png";